<template>
  <div class="container">
    <div class="title">把万饰网，克隆为自己的「外贸网站」</div>
    <div class="tip">我们全程不会向您收取任何费用</div>
    <div class="toSite" @click="toSite">克隆的网站，长这样
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path d="M16.1497 31.1494L13.8516 28.8513L22.7025 20.0004L13.8516 11.1494L16.1497 8.85132L27.2987 20.0004L16.1497 31.1494Z" fill="white"/>
      </svg>
    </div>

    <div class="main">
      <div class="main-head">
        <span class="icon"></span>
        <span class="title1">万饰网的独特功能</span>
      </div>
      <div class="main-content">
        <div class="content-title">
          所有工厂现货的「线上联合仓库」
        </div>
        <div class="content-main mt-12">
          万饰网通过一套「饰品仓库管理系统」直连每个工厂仓库，展示所有仓库产品的“实时库存”和“出厂价”，所有产品均可一键上架到您的「外贸独立站」，客户在您的独立站上看到的产品数量，就是工厂仓库的真实数量。
        </div>

        <div class="content-title mt-52">
          订制产品「快速」报价、打样、生产<span>（即将上线）</span>
        </div>
        <div class="content-main mt-12">
          万饰网通过一套标准化的「订单需求分解系统」让工厂快速响应每一个报价和打样需求，无论订单大小。
          同时，万饰网通过一套「饰品生产管理系统」，数字化管理“报价、打样、采购、外发、跟单、质检、发货”等全流程，保证过程可控、交期可控、质量可控。
        </div>

        <div class="content-title mt-52">
          傻瓜式「饰品智能设计」系统，从设计阶段锁定订单<span>（即将上线）</span>
        </div>
        <div class="content-main mt-12">
          万饰网将配件市场的所有配件进行3D建模，并把所有饰品生产工艺、材质、颜色等进行AI训练，打造成一个专业的【介入式AI饰品设计系统】，客户无需懂3D设计，无需懂生产工艺，均可自由选择自己喜欢的材质，搭配自己喜欢的颜色，设计自己喜欢的产品，系统实时呈现3D的产品真实效果。
        </div>
        <div class="content-main">
  设计完成后，系统会自动报价（您可以在后台设置您自己的提价比例），同时，客户还可以0成本、快速生成高清产品图片和视频，并可以随意摆设不同的产品角度，还可以用系统内置的AI生成不同的图片背景，然后上架到客户的电商平台去销售，出单后再向您下单，这样，客户无需向您事先询价打样，无需事先囤货，提升了客户的销售效率，同时也降低了客户的库存风险。
  因为设计时用的都是市场现成的配件和系统内置的成熟工艺，所以，大部分产品均可在3天左右交货。</div>
      </div>
    </div>

    <div class="main1">
      <div class="main-head">
        <span class="icon"></span>
        <span class="title1">克隆外贸网站的特点</span>
      </div>
      <div class="main-content">
        <div class="content-title">功能</div>
        <div class="content-main mt-12">跟万饰网一模一样。</div>
        <div class="line"></div>
        <div class="content-title">库存</div>
        <div class="content-main mt-12">实时同步工厂仓库的库存，并且每周都有新的工厂加入。</div>
        <div class="line"></div>
        <div class="content-title">新品</div>
        <div class="content-main mt-12">每周上新几十到几百款不等。</div>
        <div class="line"></div>
        <div class="content-title">收款</div>
        <div class="content-main mt-12">万饰网免费代您收款结汇<span class="tips">（跨境小额收款结汇非常麻烦，客户在您的网站上支付后，货款将自动转入万饰网的境外账户，然后结汇成人民币，万饰网扣除货款后，将剩余金额以人民币形式全额支付到您的大陆账户）。</span></div>
        <div class="rule mt-12" @click="toRule">信用卡收款与转账费用对比</div>
        <div class="line"></div>
        <div class="content-title">隐私</div>
        <div class="content-main mt-12">克隆网站使用您自己的域名，客户无法从您的网站找到万饰网，同时，万饰网也不会收集您的任何客户信息。</div>
        <div class="line"></div>
        <div class="content-title">培训</div>
        <div class="content-main mt-12">万饰网会聘请跨境独立站推广高手，手把手教您如何推广好您的网站，源源不断的获得新客户。</div>
      </div>
      <div class="icon1"></div>
      <div class="icon2"></div>
      <div class="icon3"></div>
      <div class="icon4"></div>
      <div class="icon5"></div>
      <div class="icon6"></div>
    </div>

    <div class="main main2">
      <div class="main-head">
        <span class="icon"></span>
        <span class="title1">外贸网站交易流程</span>
      </div>
      <div class="main-content">
        <div class="main-left">
          <div class="left-line"></div>
          <div class="left-radio radio1"></div>
          <div class="left-radio radio2"></div>
          <div class="left-radio radio3"></div>
          <div class="left-radio radio4"></div>
          <div class="left-radio radio5"></div>
          <div class="left-radio radio6"></div>
        </div>
        <div class="main-right">
          <div class="main-box mt-38">
            <div class="num num1"></div>
            <div class="main-title">
              客户下单
            </div>
            <div class="main-right-content">
              现货批发的，客户在线支付下单（系统会自动计算运费）；大货订制的，客户可直接跟您邮件联系，可不通过万饰网收款
            </div>
          </div>

          <div class="main-box mt-32">
            <div class="num num2"></div>
            <div class="main-title">
              接收订单
            </div>
            <div class="main-right-content">
              您在自己的网站上可以看到客户的订单
            </div>
          </div>

          <div class="main-box mt-32">
            <div class="num num3"></div>
            <div class="main-title">
              提交万饰网
            </div>
            <div class="main-right-content">
              现货单，需要您提交给万饰网发货，也可要求万饰网代发；大货单，您可以找万饰网生产，也可以自己找工厂生产
            </div>
          </div>

          <div class="main-box mt-32">
            <div class="num num4"></div>
            <div class="main-title">
              万饰网发货给您
            </div>
            <div class="main-right-content">
              万饰网收到您的发货通知后，24小时内给您发货（您负责国内运费）
            </div>
          </div>

          <div class="main-box mt-32">
            <div class="num num5"></div>
            <div class="main-title">
              您发货给客户
            </div>
            <div class="main-right-content">
              您收到万饰网的货物后，发货给您的客户
            </div>
          </div>

          <div class="main-box mt-32">
            <div class="num num6"></div>
            <div class="main-title">
              收款
            </div>
            <div class="main-right-content">
              您的客户确认收货后，万饰网将款项全额转入您的账户（万饰网将按照给您的供货价扣除货款）
            </div>
          </div>
          
        </div>
      </div>
    </div>

    <div class="main main3">
      <div class="main-head">
        <span class="icon"></span>
        <span class="title1">克隆外贸网站，只需三步</span>
      </div>
      <div class="main-content">
        <div class="section">
          <div class="section-head">
            <span class="icon1"></span>
            提供资料
          </div>
          <div class="section-content">
            1. 您公司的英文名称、公司简介、联系方式等<br>
            2. 首页广告图（我们可代为制作）及广告语<br>
            3. 您的收款账户（不限公账还是私账）
          </div>
        </div>

        <div class="section mt-16">
          <div class="section-head">
            <span class="icon2"></span>
            上架商品
          </div>
          <div class="section-content">
            1. 去万饰网的后台系统【小管饰】<br>
            &nbsp;&nbsp;&nbsp;&nbsp;www.shipin-erp.com中注册一个账号<br>
            2. 在【小管饰】的“创客中心”去选择您要上架的产品<br>
            3. 设置您的销售提价比例<br>
          </div>
        </div>

        <div class="section mt-16">
          <div class="section-head">
            <span class="icon3"></span>
            确定域名
          </div>
          <div class="section-content">
            1. 如果您没有现成的域名，需先去购买一个自己喜欢的域名（百度中搜索“域名注册”，域名费用一般为每年100元以内）<br>
            2. 如果您不懂，我们可以免费代办
          </div>
        </div>
      </div>
    </div>

    <div class="main main4">
      <div class="main-head">
        <span class="icon"></span>
        <span class="title1">克隆我的「外贸独立站」</span>
      </div>
      <div class="main-content">
        <div class="section">
          <p>方式1：扫码联系客服</p>
          <div class="kefu"></div>
          <p class="kefu-text">客服微信号</p>
        </div>
        <div class="section mt-28">
          <p>方式2：留下联系方式，等待专人对接</p>
          <p class="name"><span>*</span> 姓名</p>
          <input type="text" v-model.trim="name" maxlength="12"/>
          <p class="phone"><span>*</span> 手机号</p>
          <input type="text" v-model.trim="phone" maxlength="11" @input="validatePhone"/>
          <button class="button" :class="{active:phone.length == 11 && name.length}" :disabled="phone.length != 11 || !name" @click="submitForm">提交</button>
        </div>
      </div>
    </div>

    <div class="img"></div>
    <div class="footer">Copyright©2022-2023粤ICP备17060038号-1</div>
  </div>
</template>
<script>
export default {
  name: 'Advert1',
  components: {},
  props: {},
  data() {
    return {
      name:'',
      phone:'',
    }
  },
  watch: {},
  computed: {},
  methods: {
    validatePhone() {
      if (this.phone.length == 1 && this.phone != '1') {
        this.phone = ''
      }
      this.phone = this.phone.replace(/\D/g, '');
    },
    toSite(){
      this.$router.push(`/maker`);
    },
    toRule(){
      this.$router.push(`/advert/billingDetailAdvert`);
    },
    submitForm() {
      this.$ajax('/iap-api/wan4/maker/addTradeLink.do', { 
        linkName: this.name, 
        linkTel: this.phone 
      }).then(() => {
        this.$toastUtil.show('提交成功', 'success');
        this.name = '';
        this.phone = '';
      })
    }
  },
  created() { },
  mounted() { },
}
</script>
<style lang="less" scoped>
.container{
  width: 100%;
  background: url('https://xhdata.wan4.com/advert-bg.png') 0 0/contain no-repeat,linear-gradient(180deg, #F4F4F4 0%, #FFF6F6 5.28%);
  .title{
    font-size: 36px;
    font-weight: 600;
    line-height: 68px;
    text-align: center;
    color: #333;
    margin-top: 66px;
  }

  .tip{
    font-size: 26px;
    line-height: 34px;
    text-align: center;
    color: #666;
    margin-top: 14px;
  }

  .toSite{
    width: 348px;
    height: 76px;
    border-radius: 99px;
    background: #F16733;
    line-height: 40px;
    font-size: 28px;
    color: #fff;
    font-weight: bold;
    margin: 28px auto 0;
    padding: 18px 18px 18px 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    svg{
      width: 40px;
      height: 40px;
    }
  }

  .mt-12{margin-top: 12px;}
  .mt-16{margin-top: 16px;}
  .mt-28{margin-top: 28px;}
  .mt-32{margin-top: 32px;}
  .mt-38{margin-top: 38px;}
  .mt-52{margin-top: 52px;}

  .title1{
    font-size: 32px;
    line-height: 44px;
    font-weight: bold;
    color: #333;
  }

  .main{
    width: 702px;
    background: #fff;
    margin: 32px auto 0;
    border-radius: 8px;
    // box-shadow: 0px 2px 8px 0px #666;
    fill: #FFF;
    filter: drop-shadow(0px 2px 8px rgba(127, 5, 5, 0.15));

    .main-head{
      padding: 20px 28px;
      border-bottom: 2px solid #DCDCDC;
      line-height: 44px;
      .icon{
        width: 8px;
        height: 24px;
        background: #FF6634;
        display: inline-block;
        margin-right: 12px;
      }
      .title{
        font-size: 32px;
        line-height: 44px;
        color: #000;
      }
    }

    .main-content{
      padding: 28px 50px 38px 32px;
      .content-title{
        font-size: 28px;
        line-height: 40px;
        font-weight: bold;
        color: #333333;
        span{
          font-size: 24px;
          font-weight: 400;
          color: #999999;
        }
      }
      .content-main{
        font-size: 24px;
        line-height: 34px;
        color: #474646;
        text-indent: 20px;
      }
    }
  }

  .main1{
    width: 702px;
    border: 1px solid #FF6634;
    border-radius: 8px;
    box-shadow: 0px 2px 8px 0px #7F050526;
    margin: 32px auto 0;
    background: #fff;
    position: relative;
    overflow: auto;
    .main-head{
      padding: 20px 28px;
      background: #FFF7E8;
      border-bottom: 2px solid #FF6634;
      .icon{
        width: 8px;
        height: 24px;
        background: #FF6634;
        display: inline-block;
        margin-right: 12px;
      }
      .title{
        font-size: 32px;
        line-height: 44px;
        color: #000;
      }
    }
    .main-content{
      padding: 28px 24px 38px 32px;
      .content-title{
        font-size: 32px;
        line-height: 44px;
        color: #333;
        font-weight: 600;
      }
      .content-main{
        font-size: 24px;
        line-height: 34px;
        color: #333;
        font-weight: bold;
        span.tips{
          color: #666666;
          font-weight: 400;
        }
      }
      .line{
        width: 100%;
        height: 1px;
        background: #DCDCDC;
        margin: 28px 0;
      }
      .rule{
        color: #165DFF;
        font-size: 24px;
        line-height: 34px;
        font-weight: bold;
        text-decoration: underline;
      }
    }
    .icon1{
      width: 77px;
      height: 85px;
      background: url('https://xhdata.wan4.com/advert-icon1.png') no-repeat;
      background-size: cover;
      position: absolute;
      right: 34px;
      top: 113px;
    }
    .icon2{
      width: 77px;
      height: 82px;
      background: url('https://xhdata.wan4.com/advert-icon2.png') no-repeat;
      background-size: cover;
      position: absolute;
      right: 34px;
      top: 263px;
    }
    .icon3{
      width: 72px;
      height: 84px;
      background: url('https://xhdata.wan4.com/advert-icon3.png') no-repeat;
      background-size: cover;
      position: absolute;
      right: 34px;
      top: 408px;
    }
    .icon4{
      width: 66px;
      height: 76px;
      background: url('https://xhdata.wan4.com/advert-icon4.png') no-repeat;
      background-size: cover;
      position: absolute;
      right: 34px;
      top: 711px;
    }
    .icon5{
      width: 63px;
      height: 90px;
      background: url('https://xhdata.wan4.com/advert-icon5.png') no-repeat;
      background-size: cover;
      position: absolute;
      right: 34px;
      top: 878px;
    }
    .icon6{
      width: 91px;
      height: 81px;
      background: url('https://xhdata.wan4.com/advert-icon6.png') no-repeat;
      background-size: cover;
      position: absolute;
      right: 34px;
      bottom: 38px;
    }
  }

  .main2{
    .main-content{
      padding: 28px 38px 24px 28px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .main-left{
        width: 32px;
        min-height: 920px;
        position: relative;
        .left-line{
          width: 2px;
          height: 100%;
          background: linear-gradient(180deg, rgba(255, 102, 52, 0) 0%, #FF6634 8.5%, #FF6634 92.5%, rgba(255, 102, 52, 0) 100%);
          margin: 0 auto;
        }
        .left-radio{
          width: 32px;
          height: 32px;
          background: #fff;
          border-radius: 50%;
          border: 2px solid #FF6634;
          position: absolute;
          left: 0;
          &::after{
            content: '';
            display: inline-block;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: #FF6634;
            margin-top: 6px;
            margin-left: 6px;
          }
        }
        .radio1{ top: 42px; }
        .radio2{ top: 222px; }
        .radio3{ top: 334px; }
        .radio4{ top: 514px; }
        .radio5{ bottom: 228px; }
        .radio6{ bottom: 116px; }
      }
      .main-right{
        width: 582px;
        .num{
          position: absolute;
          left: 0;
          top: 0;
        }
        .num1{
          width: 12px;
          height: 36px;
          background: url('https://xhdata.wan4.com/advert-num1.png');
          background-size: cover;
        }
        .num2{
          width: 23px;
          height: 36px;
          background: url('https://xhdata.wan4.com/advert-num2.png');
          background-size: cover;
        }
        .num3{
          width: 20px;
          height: 36px;
          background: url('https://xhdata.wan4.com/advert-num3.png');
          background-size: cover;
        }
        .num4{
          width: 20px;
          height: 36px;
          background: url('https://xhdata.wan4.com/advert-num4.png');
          background-size: cover;
        }
        .num5{
          width: 20px;
          height: 36px;
          background: url('https://xhdata.wan4.com/advert-num5.png');
          background-size: cover;
        }
        .num6{
          width: 20px;
          height: 36px;
          background: url('https://xhdata.wan4.com/advert-num6.png');
          background-size: cover;
        }
        .main-box{
          padding-left: 32px;
          position: relative;
          .main-title{
            font-size: 28px;
            font-weight: 600;
            line-height: 40px;
            color: #333;
          }
          .main-right-content{
            font-size: 24px;
            line-height: 34px;
            color: #666;
            margin-top: 6px;
          }
        }
      }
    }
  }

  .main3{
    .main-content{
      padding: 32px 28px 38px;
      .section{
        box-shadow: 0px 4px 12px 0px #0000002E;
        border-radius: 8px;
        border: 1px solid #DCDCDC;
        padding: 0 20px;
        .section-head{
          span.icon1{
            width: 18px;
            height: 39px;
            display: inline-block;
            background: url('https://xhdata.wan4.com/advert-icon7.png') no-repeat;
            background-size: contain;
            position: relative;
            top: 8px;
            margin-right: 14px;
          }
          span.icon2{
            width: 29px;
            height: 37px;
            display: inline-block;
            background: url('https://xhdata.wan4.com/advert-icon8.png') no-repeat;
            background-size: contain;
            position: relative;
            top: 8px;
            margin-right: 14px;
          }
          span.icon3{
            width: 30px;
            height: 39px;
            display: inline-block;
            background: url('https://xhdata.wan4.com/advert-icon9.png') no-repeat;
            background-size: contain;
            position: relative;
            top: 8px;
            margin-right: 14px;
          }
          font-size: 28px;
          line-height: 80px;
          color: #333;
          font-weight: 600;
          border-bottom: 2px dashed #FF6634;
        }
        .section-content{
          padding: 24px 0 28px;
          font-size: 24px;
          line-height: 40px;
          color: #474646;
        }
      }
    }
  }

  .main4{
    .main-content{
      padding: 28px 28px 38px;
      .section{
        width: 646px;
        padding: 28px;
        border: 1px solid #FF6634;
        border-radius: 12px;
        background: #FFF7E8;
        font-size: 28px;
        line-height: 40px;
        font-weight: 600;
        color: #333;
        p{margin: 0;}
        .kefu{
          width: 200px;
          height: 200px;
          margin-top: 18px;
          margin-left: 22px;
          background: url('https://xhdata.wan4.com/erp-pc-235.png') no-repeat;
          background-size: contain;
        }
        .kefu-text{
          color: #666;
          font-weight: 400;
          padding-left: 50px;
          margin-top: 8px;
        }
        .name{
          font-size: 28px;
          color: #333;
          line-height: 40px;
          margin-top: 18px;
          span{
            color: #F53F3F;
            padding-top: 8px;
          }
        }
        .phone{
          font-size: 28px;
          color: #333;
          margin-top: 24px;
          span{
            color: #F53F3F;
            padding-top: 8px;
          }
        }
        input{
          background: #fff;
          width: 480px;
          height: 70px;
          border: 1px solid #DCDCDC;
          border-radius: 4px;
          font-size: 24px;
          line-height: 70px;
          padding: 0 18px;
          margin-top: 8px;
        }
        .button{
          width: 590px;
          height: 68px;
          display: block;
          border-radius: 8px;
          background: #C9CDD4;
          font-size: 28px;
          line-height: 50px;
          text-align: center;
          margin-top: 28px;
          color: #fff;
          outline: 0;
          border-width: 0;
          &.active{
            background: #FF6634;
          }
        }
      }
    }
  }
  
  .img{
    width: 100%;
    height: 68px;
    background: url("https://xhdata.wan4.com/advert-img1.png") no-repeat;
    background-size: contain;
    margin-top: 58px;
  }
  .footer{
    width: 100%;
    height: 100px;
    background: #131313;
    font-size: 24px;
    text-align: center;
    line-height: 100px;
    color: #999999;
  }
}
</style>